// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Aid_textarea__GQ7LP"};